import { Question, Section } from '@playbooks/core/src/interfaces/ActionCard'

import { WebPlayQuestionFileUploadStorageService } from './WebPlayQuestionFileUploadStorageService'

export class FileUploadServiceProvider {
  storageId: string

  constructor(storageId: string) {
    this.storageId = storageId
  }

  getService(question: Question) {
    return new FileUploadService(this.storageId, question)
  }
}

class FileUploadService {
  storageId: string
  question: Question
  storageService: WebPlayQuestionFileUploadStorageService

  get isDisabled() {
    return !this.storageId
  }

  constructor(storageId: string, question: Question) {
    this.storageId = storageId
    this.question = question
    this.storageService = new WebPlayQuestionFileUploadStorageService(this.storageId)
  }

  async deleteFile(fileItem: { id: number; name: string }) {
    await this.storageService.deleteFile(fileItem)
  }

  async uploadFiles(uploadingFiles: File[], currentHeader: Section) {
    const newFileItems = []
    for (let i = 0; i < uploadingFiles.length; i++) {
      const file = uploadingFiles[i]
      try {
        if (file.size > 30 * 1024 * 1024) {
          throw new Error('File size exceeds the limit of 30MB')
        }
        await this.storageService.saveFile(this.question, currentHeader, file).then(id => {
          newFileItems.push({ id: id, name: file.name })
        })
      } catch (error: unknown) {
        newFileItems.push({ id: 0, name: file.name, error: error instanceof Error ? error.message : String(error) })
      }
    }
    return newFileItems
  }
}
